import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles(({ palette }) => ({
  root: {
    color: grey[600],
  },
  label: {
    width: "100%",
    fontSize: 14,
    color: grey[600],
    "&.Mui-disabled": {
      color: palette.disabledText.main,
    },
  },
  checked: {
    "& + .MuiFormControlLabel-label": {
      color: "black",
    },
  },
  radioContent: {
    display: "flex",
    justifyContent: "flex-end",
  },
  radioContentStart: {
    display: "flex",
    justifyContent: "flex-start",
  },
  radioContentFill: {
    flex: "0 0 100%",
    display: "flex",
    justifyContent: "flex-fill",
  },
  radioContentFull: {
    flex: "0 0 100%",
    display: "flex",
    justifyContent: "flex-fill",
    padding: 0,
    width: "90%",
  },
  radioContentForm: { padding: 0, width: "90%" },
}));

export default useStyles;
